import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocationsSelectedCounter = createSelector(
  [(store: RootState) => store.userProfileLocation.selectedLocations],
  // Devuelve el listado de locations seleccionados o asignados ordenados por nombre
  (data) => data.length
);